module.exports = {
          srcSet: __webpack_public_path__ + "public/8c9182c39e1e541ab69f3642a7b49dcc-800.png"+" 800w",
          images:[ {path: __webpack_public_path__ + "public/8c9182c39e1e541ab69f3642a7b49dcc-800.png",width: 800,height: 1025}],
          src: __webpack_public_path__ + "public/8c9182c39e1e541ab69f3642a7b49dcc-800.png",
          toString:function(){return __webpack_public_path__ + "public/8c9182c39e1e541ab69f3642a7b49dcc-800.png"},
          
          width: 800,
          height: 1025
        }